import { render } from "./imagegallery.vue?vue&type=template&id=07bfe6e4&scoped=true"
import script from "./imagegallery.vue?vue&type=script&lang=js"
export * from "./imagegallery.vue?vue&type=script&lang=js"

import "./imagegallery.vue?vue&type=style&index=0&id=07bfe6e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07bfe6e4"]])

export default __exports__